import { Select } from 'components/Select/Select'
import { Item } from '@react-stately/collections'
import { Text } from 'blaze-ui/Text/Text'
import { useField } from 'formik'
import { LengthSelectProps } from 'components/AddCampaignModal/CreateCampaign/Types'

export const LengthSelect = ({ name, ...rest }: LengthSelectProps) => {
  const [lengthField, , { setValue: setLength }] = useField<number>(name)
  return (
    <Select
      {...rest}
      selectedKey={String(lengthField.value)}
      variant="secondary"
      size="lg"
      aria-label="Select Length"
      onSelectionChange={(key) => setLength(Number(key))}
    >
      <Item key={1} textValue="1 Week">
        <Text variant="primary" color="inherit">
          1 week
        </Text>
      </Item>
      <Item key={2} textValue="2 Weeks">
        <Text variant="primary" color="inherit">
          2 weeks
        </Text>
      </Item>
      <Item key={3} textValue="3 Weeks">
        <Text variant="primary" color="inherit">
          3 weeks
        </Text>
      </Item>
      <Item key={4} textValue="4 Weeks">
        <Text variant="primary" color="inherit">
          4 weeks
        </Text>
      </Item>
    </Select>
  )
}
